<template>
	<section class="Segments">
		<div
			class="segment"
			v-for="segment in segments"
			:key="segment.label"
			:class="{ open: openedSegments.includes(segment.label) }"
			:style="{ '--count': segment.children.length }"
		>
			<A class="title" @click="toggleSegment(segment.label)">{{ segment.label }}</A>
			<Form :form="getForm(segment)" :data="getFormData(segment)" @change="onSelectOption" />
		</div>
		<Button :disabled="!this.selectedOption" @click="onConfirm">{{ button }}</Button>
	</section>
</template>

<script>
	export default {
		props: ['segments', 'button'],
		data() {
			return {
				openedSegments: [],
				selectedSegment: null,
				selectedOption: null
			};
		},
		methods: {
			getForm(segment) {
				return [
					{
						type: 'radio',
						name: segment.label,
						options: segment.children,
						multiselect: false
					}
				];
			},
			getFormData(segment) {
				if (this.selectedSegment === segment.label) {
					return {
						[segment.label]: this.selectedOption
					};
				} else {
					return {
						[segment.label]: ''
					};
				}
			},
			onSelectOption(key, value) {
				this.selectedSegment = key;
				this.selectedOption = value;
			},
			toggleSegment(segment) {
				if (this.openedSegments.includes(segment)) {
					this.openedSegments = this.openedSegments.filter(s => s !== segment);
				} else {
					this.openedSegments = [...this.openedSegments, segment];
				}
			},
			onConfirm() {
				this.$emit('select', { segment: this.selectedSegment, option: this.selectedOption });
			}
		}
	};
</script>

<style scoped lang="scss">
	.Segments {
		padding: 1rem 1.6rem;

		.segment {
			min-width: 24rem;
			&:not(:first-of-type) {
				margin-top: 1rem;
			}

			.title {
				border: solid 1px currentColor;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-radius: 0.5rem;
				padding: 0.5rem 1rem;
				color: var(--clrTheme);

				&::after {
					content: '\e90a';
					font-family: 'icomoon';
					color: inherit;
					transform: rotate(-90deg);
					transition: transform 0.3s;
				}
			}

			/deep/ .Form {
				max-height: 0;
				overflow: hidden;
				transition: max-height 0.3s;

				.input-area {
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					color: white;
					margin: 0;

					.checkbox {
						color: inherit;
						margin: 0;
						margin-top: 1rem;
						background-color: var(--clrTheme);
						width: calc(100% - 6rem) !important;
						padding: 0.5rem 1rem;
						border-radius: 0.4rem;
						transition: all 0.3s;

						&.checked {
							&::before {
								color: var(--clrTheme);
								background-color: white;
							}
						}

						span {
							color: inherit;
						}

						&::before {
							border-color: white;
							transition: all 0.3s;
						}
					}
				}
			}

			&.open {
				.title {
					&::after {
						transform: rotate(90deg);
					}
				}

				/deep/ .Form {
					max-height: calc(var(--count) * 5rem);
				}
			}
		}

		.Button {
			margin-top: 1rem;
			width: 100%;
		}
	}
</style>
